<template>
<div id="auditoria_cargos_datastage" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="AUDITORÍA/VALIDACIÓN DE CARGOS" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'in-view'" >Vista Previa</v-tab>
            <v-tab :key="'in-report'" >Generar en Reporte</v-tab>

            <v-tab-item :key="'in-view'" >
               <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                        <v-row row wrap>
                        <v-col cols="12" sm="3" md="3" lg="3" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field clearable v-on="on" v-model="model.fecha_entrada" label="Fecha Pago Original" color="secondary" prepend-icon="event" @blur="model.fecha_entrada = parseDate(model.fecha_entrada)" v-mask="'####-##-##'"
                                  :rules="[validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_entrada" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>                        
                        <v-col cols="12" sm="2" md="2" lg="2" >
                            <v-autocomplete v-model="model.anio" 
                                    :items="anios" :hide-no-data="true"  
                                    :loading="anio_loading"
                                    :return-object="false"  label="Año">
                                </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2" >
                            <v-autocomplete v-model="model.mes" 
                                    :items="meses" :hide-no-data="true" 
                                    item-text="mes" item-value="id"
                                    :return-object="false"  label="Mes">
                                </v-autocomplete>
                        </v-col>
                      </v-row> 

                        <v-row no-row wrap>
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.clave_documento" 
                                    :items="claves" :hide-no-data="true"     
                                    clearable :loading="clave_loading"  
                                    :return-object="false"  label="Clave Documento">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="3" sm="3" lg="3">
                                <v-text-field label="Número Pedimento" clearable maxlength="20" 
                                v-model="model.numero_pedimento" :rules="[validaPedimento]">  
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" sm="1" lg="1">
                                <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                  <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                </v-btn>
                            </v-col>                                                  
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.activo" :items="list_activos" :hide-no-data="true" 
                                    item-text="text" item-value="id"                                    
                                    :return-object="false"  label="Activo Fijo"                                     
                                    >
                                </v-autocomplete>
                            </v-col>                      
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-text-field label="Fracción" clearable v-model="model.fraccion" maxlength="10">  
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-btn color="info" @click="genera_consulta" >
                                    <v-icon>done</v-icon>Consultar
                                </v-btn>              
                            </v-col>
                      </v-row>                    
                    </v-container>

                  </v-form>
                </v-card-text>
                
                <v-card-text>                  
                  <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                    </template>
                    
                    <template slot="beforeTable">
                      <div style="text-align:right" v-if="datos.length>0">
                        <exportar-excel :data="datafiltered" :exportFields="encabezadosExportar" name="Validacion_Cargos.xlsx">
                            <v-btn small color="green" title="Exportar Excel" v-tippy>
                                <v-icon dark>mdi-table</v-icon> Exportar
                            </v-btn>
                        </exportar-excel>
                      </div>
                    </template>

                    <template slot="clave_documento" slot-scope="props">
                      <div style="text-align:center">{{props.row.clave_documento}}</div>
                    </template>
                    <template slot="no_pedimento" slot-scope="props">
                      <div style="text-align:center">{{props.row.no_pedimento}}</div>
                    </template>
                    <template slot="identificador" slot-scope="props">
                      <div style="text-align:center">{{props.row.identificador}}</div>
                    </template>
                    <template slot="fecha" slot-scope="props">
                      <div style="text-align:center">{{parseDate(props.row.fecha)}}</div>
                    </template>
                    <template slot="anio" slot-scope="props">
                      <div style="text-align:center">{{props.row.anio}}</div>
                    </template>
                    <template slot="mes" slot-scope="props">
                      <div style="text-align:center">{{props.row.mes}}</div>
                    </template>
                    <template slot="fraccion" slot-scope="props">
                      <div style="text-align:right">{{props.row.fraccion}}</div>
                    </template>
                    <template slot="valor_comercial" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.valor_comercial, 2)}}</div>
                    </template>
                    <template slot="valor_comercial_total" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.valor_comercial_total, 2)}}</div>
                    </template>
                    <template slot="importe_iva" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.importe_iva, 2)}}</div>
                    </template>
                    <template slot="importe_ieps" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.importe_ieps, 2)}}</div>
                    </template>

                    <template slot="afterTable">
                      <div style="text-align:right">
                        <span>Valor Comercial Total: </span> <span style="font-size:18px;"><strong>{{ formatNumberDec(sumadatafiltered, 2) }} </strong></span>
                      </div>
                    </template>

                  
                  </v-client-table>
                </v-card-text>
            </v-tab-item>

            <v-tab-item :key="'in-report'" >
              <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="formreporte" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                        <v-row row wrap>
                        <v-col cols="12" sm="3" md="3" lg="3" >
                          <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field clearable v-on="on" v-model="model.fecha_de" label="Fecha Pago Original Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                  :rules="(model.numero_pedimento!=undefined && model.numero_pedimento.toString().trim()!='')?[validaAnio, validaDias, validaFecha]:[rules.required, validaAnio, validaDias, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu3 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" >
                          <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field clearable v-on="on" v-model="model.fecha_a" label="Fecha Pago Original Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="(model.numero_pedimento!=undefined && model.numero_pedimento.toString().trim()!='')?[validaAnio, validaDias, validaFecha]:[rules.required, validaAnio, validaDias, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu4 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <!--v-col cols="12" sm="2" md="2" lg="2" >
                            <v-autocomplete v-model="model.anio" 
                                    :items="anios" :hide-no-data="true"  
                                    :loading="anio_loading"
                                    :return-object="false"  label="Año">
                                </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2" >
                            <v-autocomplete v-model="model.mes" 
                                    :items="meses" :hide-no-data="true" 
                                    item-text="mes" item-value="id"
                                    :return-object="false"  label="Mes">
                                </v-autocomplete>
                        </v-col-->
                      </v-row> 

                        <v-row no-row wrap>
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.clave_documento" 
                                    :items="claves" :hide-no-data="true"     
                                    clearable :loading="clave_loading"  
                                    :return-object="false"  label="Clave Documento">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="3" sm="3" lg="3">
                                <v-text-field label="Número Pedimento" clearable maxlength="20" 
                                v-model="model.numero_pedimento" :rules="[validaPedimento]">  
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" sm="1" lg="1">
                                <v-btn icon title="Pegar Listado" @click="dialog2 = !dialog2" v-tippy>
                                  <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                </v-btn>
                            </v-col>                                                  
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.activo" :items="list_activos" :hide-no-data="true" 
                                    item-text="text" item-value="id"                                    
                                    :return-object="false"  label="Activo Fijo"                                     
                                    >
                                </v-autocomplete>
                            </v-col>                      
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-text-field label="Fracción" clearable v-model="model.fraccion" maxlength="10">  
                                </v-text-field>
                            </v-col>           
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-btn color="success" @click="generar_reporte" >
                                    <v-icon>done_all</v-icon>Generar Reporte
                                </v-btn>              
                            </v-col>                            
                      </v-row>                    
                    </v-container>

                  </v-form>
                </v-card-text>
                
                <v-card-text>           
                  <v-refresh-button :funcion="cargar" />       
                  <v-client-table ref="vuetable2" :data="reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                    </template>
                    
                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  
                  </v-client-table>
                </v-card-text>
            </v-tab-item>
          </v-tabs>              

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListadoPreview]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="generaConsultaListado();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog2" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListado]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog2 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="generaReporteListado();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;    
    this.tipo = 1;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");    
    this.getClaves();
    this.getAnios();
    this.model.mes = parseInt(moment().format('MM'));
    //this.getFracciones();
    this.cargar();
  },
  computed: {
    datafiltered() {
        let result = [];
        if (this.$refs.vuetable != null) {
            result = this.$refs.vuetable.allFilteredData;
            return result;
        } else {
            result = this.datos;
            return result;
        }
    },
    sumadatafiltered() {
        let result = [];
        var suma = 0;
        if (this.$refs.vuetable != null) {            
            result = this.$refs.vuetable.allFilteredData;            
        } else {
            result = this.datos;            
        }
        for(var k in result){
            suma += parseFloat(result[k]["valor_comercial"]);
        }
        return suma;
    },
  },
  data: () => ({
    anio_loading:false,
    clave_loading:false,
    claves:[],
    anios:[],
    meses:[
        {"id":1,"mes":"ENERO"}, 
        {"id":2,"mes":"FEBRERO"},
        {"id":3,"mes":"MARZO"},
        {"id":4,"mes":"ABRIL"},
        {"id":5,"mes":"MAYO"},
        {"id":6,"mes":"JUNIO"},
        {"id":7,"mes":"JULIO"},
        {"id":8,"mes":"AGOSTO"},
        {"id":9,"mes":"SEPTIEMBRE"},
        {"id":10,"mes":"OCTUBRE"},
        {"id":11,"mes":"NOVIEMBRE"},
        {"id":12,"mes":"DICIEMBRE"}],
    permisoEliminar:false,
    list_activos:[
        {"id":"N","text":"No"}, //No Activo Fijos
        {"id":"S","text":"Si"}, //Activo Fijo
        {"id":"","text":"Todos"}],
    fracciones: [],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Auditorías",
        disabled: true,
        to: ""
      },
      {
        text: "Validación de Cargos",
        disabled: true,
        to: ""
      },
      {
        text: "Auditoría/Validación de Cargos",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    reportes: [],
    encabezadosExportar:{
        "Régimen de Operación":"regimen",
        "Numero de Pedimento":"no_pedimento",
        "Tipo de Pedimento":"tipo_pedimento",
        "Fecha Pago Original":"fecha",
        "Número Pedimento Original":"pedimento_original",
        "Año":"anio",
        "Mes":"mes",
        "Clave Documento":"clave_documento",
        "Regla de Plazo":"fundamento",
        "Identificadores":"identificadores",        
        "Fraccion Arancelaria":"fraccion",        
        "Descripción":"descripcion",
        "Activo Fijo":"identificador",
        "Valor Comercial x FA":"valor_comercial",
        "Valor Comercial Total":"valor_comercial_total",
        "Importe IVA FP 21 o 22":"importe_iva",
        "Importe IEPS FP 21 o 22":"importe_ieps",
    },
    columns: [
            "regimen",
            "no_pedimento",
            "tipo_pedimento",
            "fecha",
            "pedimento_original",
            "clave_documento",            
            "fundamento",
            "identificadores",            
            "fraccion",            
            "descripcion",
            "identificador",            
            "valor_comercial",
            "valor_comercial_total",
            "importe_iva",
            "importe_ieps"

            ],
    options: {
      filterable: true,
      sortable: true,

      headings: {
        "regimen":"Régimen de Operación",
        "fundamento":"Regla de Plazo",
        "clave_documento":"Clave Documento",
        "no_pedimento":"Numero de Pedimento",
        "tipo_pedimento":"Tipo de Pedimento",
        "pedimento_original":"Número Pedimento Original",
        "identificador":"Activo Fijo",
        "fecha":"Fecha Pago Original",              
        "fraccion":"Fraccion Arancelaria",        
        "descripcion":"Descripción",
        "identificadores":"Identificadores",
        "valor_comercial":"Valor Comercial x FA",
        "valor_comercial_total":"Valor Comercial Total",
        "importe_iva":"Importe IVA FP 21 o 22",
        "importe_ieps":"Importe IEPS FP 21 o 22",
      }
    },
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    show_loading: true,
    list_reportes: [
            {
                "reporte": "Pref. Arancelarias Activo Fijo WS",
                "url": "/reportes_ws/partidas_activo_fijo/"
            },
            {
                "reporte": "Pref. Arancelarias Activo Fijo DS",
                "url": "/reportes_ds/partidas_activo_fijo_ds/"
            },            
    ],
    listado:"",
    dialog1:false,
    dialog2:false,
    model: {
      rfc: "",
      usuario: "",
      fecha_entrada:"",
      fecha_de: "",
      fecha_a:"",
      anio:"",
      mes:"",
      activo: "",
      fraccion: "",
      numero_pedimento:"",
      lista:[],
      clave_documento:"",      
    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,

  }),
  methods: {   
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: "VALIDACION CARGOS"
      };
      axios.post(this.$apiSA31 + "soluciona31/reportes/get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.reportes = res.data;
            this.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud)
            });
            for (var k in this.reportes) {
              this.reportes[k].fecha_solicitud = this.parseDate(this.reportes[k].fecha_solicitud);
              this.reportes[k].fecha_generacion = this.parseDate(this.reportes[k].fecha_generacion);
              this.reportes[k].estatus = this.getEstatus(this.reportes[k].estatus);
              this.reportes[k].criterio = this.getCriterioPredeterminados(this.reportes[k].criterio);
            }
          }
        })
        .catch(err => {

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores",
        "No Recuperable", "Token Incorrecto", "Reprogramado", , "Pendiente AA"
      ];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          
            if (params.lista != undefined && params.lista.length > 0) {
              return "Buscado por lista de pedimentos: " + params.lista.length;
            } else if (params.numero_pedimento && params.numero_pedimento != ""){
              return "Pedimento: " + params.numero_pedimento;
            }else {
              var txt = "";
              if (params.fecha_de && params.fecha_de != "")
                  txt += "Fecha De: " + params.fecha_de+", ";
              if (params.fecha_a && params.fecha_a != "")
                  txt += " Fecha A: " + params.fecha_a+", ";
              if (params.fraccion && params.fraccion != "")
                  txt += " Fracción: " + params.fraccion+", ";
              if (params.activo && params.activo != "")
                  txt += " Activo: " + params.activo+", ";
              if (params.clave_documento && params.clave_documento != "")
                  txt += " Clave Doc: " + params.clave_documento;                        
              return txt;
            }
              
          
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    validaDiasPreview: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."        
      }
      return true;
    },
    validaPedimento: function(val){
      if (val && val!="" && !this.validarPatronPedimento(val))
          return "Pedimento no válido. Ejemplo: 240-0123-0000123";
      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaListadoPreview: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 pedimento. Favor de verificar.";
      } else if (listadoSinEspacios.length > 15) {
        return "No se puede consultar mas de 15 pedimentos en Vista Previa";
      } else {
        for (var k in listadoSinEspacios) {
          if (!this.validarPatronPedimento(listadoSinEspacios[k]))
            return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
        }
      }

      return true;
    },
    validaListado: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 pedimento. Favor de verificar.";
      } else if (listadoSinEspacios.length > 50) {
        return "No se puede consultar mas de 50 pedimentos";
      } else {
        for (var k in listadoSinEspacios) {
          if (!this.validarPatronPedimento(listadoSinEspacios[k]))
            return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
        }
      }

      return true;
    },
    removerLineasVacias(listado) {
      var listadoSplit = this.listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      listadoSinEspacios = listadoSinEspacios.map(item => {
        return item.trim();
      });
      return listadoSinEspacios;
    },
    generaConsultaListado() {
      if (this.$refs.formListado.validate()) {
        this.genera_consulta("listado");        
        this.dialog1 = false;        
      }
    },
    generaReporteListado() {
      if (this.$refs.formListado.validate()) {
        this.generar_reporte("listado");        
        this.dialog2 = false;
      }
    },
    formatNumberDec: function(numero, decimales){
        if (numero == undefined || numero == null || numero == "")
            numero = 0;
        numero = Number(numero);
        if (isNaN(numero)){
            return "";
        } else
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    getFracciones:function(){
       this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = {
            "identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.fracciones = response.data
                } else {
                    this.fracciones = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
              footer: ""
            });
          }).then(() => {            
            this.$root.$dialogLoader.hide();
          }); 
    },
    getClaves:function(){
       this.clave_loading = true;
        var data = {
            //"identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_claves_documento_a31/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.claves = response.data
                } else {
                    this.claves = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las claves documentos. Intente nuevamente.",
              footer: ""
            });
          }).then(()=>{
            this.clave_loading = false;
          }); 
    },
    getAnios:function(){
       this.anio_loading = true;
        var data = {
            //"identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_anios_a31/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.anios = response.data
                } else {
                    this.anios = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener los años. Intente nuevamente.",
              footer: ""
            });
          }).then(()=>{
            this.model.anio = parseInt(moment().format('YYYY'));            
            if(!this.anios.includes(this.model.anio) && this.anios.length>0){
                this.model.anio = this.anios[this.anios.length - 1];                
            }
            this.anio_loading = false;
          }); 
    },
    generar_reporte(opcion) {
      if (!this.$refs.formreporte.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = JSON.parse(JSON.stringify(this.model)); 

        data["reporte_url"] = "/soluciona31/reportes/rpt_cargos_ds/";
        data["nombre_reporte"] = "Auditoria/Validación Cargos";
        data["tipo"] = "VALIDACION CARGOS";

        if( opcion == "listado"){
          data["lista"] = this.removerLineasVacias(this.listado);
          delete(data['numero_pedimento']);
          delete(data['fecha_de']);
          delete(data['fecha_a']);
          delete(data['anio']);
          delete(data['mes']);          
        } else {
          delete(data['lista']);
        }
        delete(data['fecha_entrada']); //esta fecha solo es en preview              

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",                                 
            data: data
          })
          .then(response => {            
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {            
            this.$root.$dialogLoader.hide();
            this.cargar();
            
          });
      }
    },
    genera_consulta(opcion) {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {                 
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.datos = [];
        var data = JSON.parse(JSON.stringify(this.model)); 

        if( opcion == "listado"){
          data["lista"] = this.removerLineasVacias(this.listado);
          delete(data['numero_pedimento']);
          delete(data['fecha_entrada']);         
          delete(data['anio']);
          delete(data['mes']);          
        } else {
          delete(data['lista']);
        }
        delete(data['fecha_de']);
        delete(data['fecha_a']);
        

        console.log("DATA: ", data);        
        //return false;

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/cargos_ds_preview/",                                 
            data: data
          })
          .then(response => {
            this.datos = response.data; 
          })
          .catch(error => {
            var mensaje = "";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;              
            } 
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al generar la consulta",
              footer: mensaje
            });
          }).then(() => {            
            this.$root.$dialogLoader.hide();
          });
      }
    },

    downloadReporte: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },
 
    
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>
